import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import FieldIconWrapper from 'common/components/form/FieldIconWrapper';

import moment from 'moment';
import 'moment/locale/es';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';

class DatePicker extends PureComponent {
  state = { date: '', initialValue: false };

  componentWillReceiveProps = () => {
    const date = moment(this.props.value);
    if (date.isValid() && !this.state.initialValue) {
      this.setState({ date: date.format('DD/MM/YYYY'), initialValue: true });
    }
  };

  componentDidMount = () => {
    this.props.value = '';
    this.setState({ date: '', initialValue: false });
  };

  handleChange = (day) => {
    const date = moment(day);
    date.target = { name: this.props.name };
    this.props.handleChange(date);
  };

  render = () => (
    <DayPickerInput
      inputProps={{
        className: classnames('form-control w-100', {
          [`form-control-${this.props.inputSize}`]: !!this.props.inputSize,
          'is-invalid':
            this.props.passThroughProps.error &&
            Object.keys(this.props.passThroughProps.error).length > 0,
        }),
      }}
      formatDate={formatDate}
      parseDate={parseDate}
      dayPickerProps={{ locale: 'es', localeUtils: MomentLocaleUtils }}
      format="DD/MM/YYYY"
      name={this.props.name}
      onDayChange={this.handleChange}
      placeholder={`DD/MM/YYYY`}
      value={this.state.date}
    />
  );
}

export const FieldDate = ({
  name = '',
  value = '',
  placeholder,
  autoFocus,
  inputSize,
  isLoading = false,
  handleChange = () => {},
  t,
  ...passThroughProps
}) => (
  <FieldIconWrapper {...passThroughProps} formatDate={'DD/MM/YYYY'}>
    <DatePicker
      name={name}
      value={value}
      placeholder={placeholder}
      autoFocus={autoFocus}
      inputSize={inputSize}
      isLoading={isLoading}
      handleChange={handleChange}
      passThroughProps={passThroughProps}
    />
  </FieldIconWrapper>
);

FieldDate.propTypes = {
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  error: PropTypes.object,
  handleChange: PropTypes.func,
  inputSize: PropTypes.oneOf(['lg', 'sm']),
  iconRight: PropTypes.string,
  iconLeft: PropTypes.string,
  iconRightSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconRightSpin: PropTypes.bool,
  iconLeftSize: PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
  iconLeftSpin: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default translate()(FieldDate);



// WEBPACK FOOTER //
// src/modules/common/components/form/FieldDate.js